(function () {
"use strict";
function readNormafyProductData(builder) {
  var dataNode = builder.querySelector(".normafy-product-data");
  if (!dataNode) return {};
  try {
    return JSON.parse(dataNode.textContent);
  } catch (error) {
    console.error("NÖRMAFY product data parse error:", error);
    return {};
  }
}

var NORMA_TEE_IMAGES = {
black: {
white: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-black-front-and-back-6a346b782c459.jpg?v=1781820293"
},
white: {
black: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-white-front-and-back-6a34694b88208.jpg?v=1781819755"
},
cream: {
black: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-vintage-white-front-and-back-6a34694b7f8aa.jpg?v=1781819754",
white: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-vintage-white-front-and-back-6a346abc67a06.jpg?v=1781820118"
},
asphalt: {
black: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-asphalt-front-and-back-6a34694b5ec41.jpg?v=1781819754",
white: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-asphalt-front-and-back-6a346abc4b8fe.jpg?v=1781820118"
},
"team-purple": {
black: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-team-purple-front-and-back-6a34694b56dd1.jpg?v=1781819754",
white: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-team-purple-front-and-back-6a346abc437e8.jpg?v=1781820118"
},
cardinal: {
black: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-cardinal-front-and-back-6a34694b58cec.jpg?v=1781819755",
white: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-cardinal-front-and-back-6a346abc45bff.jpg?v=1781820117"
},
"military-green": {
black: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-military-green-front-and-back-6a34694b5b9fb.jpg?v=1781819755",
white: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-military-green-front-and-back-6a346abc483f8.jpg?v=1781820118"
},
"light-blue": {
black: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-light-blue-front-and-back-6a34694b6286a.jpg?v=1781819755",
white: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-light-blue-front-and-back-6a346abc4fa2c.jpg?v=1781820118"
},
"soft-pink": {
black: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-soft-pink-front-and-back-6a34694b77fdc.jpg?v=1781819755",
white: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-soft-pink-front-and-back-6a346abc60594.jpg?v=1781820117"
},
"ocean-blue": {
black: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-ocean-blue-front-and-back-6a34694b68a5f.jpg?v=1781819755",
white: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-ocean-blue-front-and-back-6a346abc54503.jpg?v=1781820118"
},
yellow: {
black: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-yellow-front-and-back-6a34694b70e2c.jpg?v=1781819755",
white: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-yellow-front-and-back-6a346abc59d93.jpg?v=1781820118"
}
};
var CATALOG = {
bases: {
"tee": {
label: "Tee",
image: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/Blank_black_tee.png?v=1779053120",
sizeChartId: "teeSizeChart"
},
"tanktop": {
label: "Tank Top",
image: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/Blank_black_tank.png?v=1779053345",
sizeChartId: "tankSizeChart"
}
},
colors: {
"black":         { label: "Black",          swatch: "#111111" },
"white":         { label: "White",          swatch: "#ffffff", border: true },
"cream":         { label: "Cream",          swatch: "#f3ead7" },
"asphalt":       { label: "Asphalt",        swatch: "#707070" },
"team-purple":   { label: "Team Purple",    swatch: "#2f1b52" },
"cardinal":      { label: "Cardinal",       swatch: "#8f1728" },
"military-green":{ label: "Military Green", swatch: "#555440" },
"light-blue":    { label: "Light Blue",     swatch: "#d1dce9" },
"soft-pink":     { label: "Soft Pink",      swatch: "#efb9c5" },
"ocean-blue":    { label: "Ocean Blue",     swatch: "#65bfd4" },
"yellow":        { label: "Yellow",         swatch: "#f4bf32" },
"pink":          { label: "Pink",           swatch: "#f4b6c2" }
},
designs: {
"norma-tee": {
label: "Nörma Tee",
image: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/NORMA-LOGO.png?v=1779050341"
},
"norma-1st-edition": {
label: "1st Edition",
image: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/NORMA-LOGO.png?v=1779050341"
},
"norma-signature": {
label: "Nörma Signature",
image: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/Norma_Signature-FINAL-BLK.png?v=1779050308"
},
"crowned-norma": {
label: "Crowned Nörma",
image: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/Crowned_Norma2.0-blk.svg?v=1779650834"
},
"oboi": {
label: "O'Boi",
image: "https://cdn.shopify.com/s/files/1/0766/6103/1153/files/O_Boi_Black_V2.png?v=1786937438"
}
},
inks: {
"white": { label: "White", swatch: "#ffffff", border: true },
"black": { label: "Black", swatch: "#111111" }
},
sizes: {
"xsmall": { label: "XS", shopify: "XS" },
"small":  { label: "S",  shopify: "S" },
"medium": { label: "M",  shopify: "M" },
"large":  { label: "L",  shopify: "L" },
"xlarge": { label: "XL", shopify: "XL" }
},
combinations: [
{ base:"tee", color:"black", design:"norma-tee", ink:"white", handle:"norma-tee-black-version", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Black", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-black-front-and-back-6a346b782c459.jpg?v=1781820293" },
{ base:"tee", color:"white", design:"norma-tee", ink:"black", handle:"norma-tee-1", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"White", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-white-front-and-back-6a34694b88208.jpg?v=1781819755" },
{ base:"tee", color:"cream", design:"norma-tee", ink:"black", handle:"norma-tee-1", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Vintage White", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-vintage-white-front-and-back-6a34694b7f8aa.jpg?v=1781819754" },
{ base:"tee", color:"cream", design:"norma-tee", ink:"white", handle:"norma-tee-black-version", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Vintage White", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-vintage-white-front-and-back-6a346abc67a06.jpg?v=1781820118" },
{ base:"tee", color:"asphalt", design:"norma-tee", ink:"black", handle:"norma-tee-1", sizes:["small","medium","large","xlarge"], variantColor:"Asphalt", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-asphalt-front-and-back-6a34694b5ec41.jpg?v=1781819754" },
{ base:"tee", color:"asphalt", design:"norma-tee", ink:"white", handle:"norma-tee-black-version", sizes:["small","medium","large","xlarge"], variantColor:"Asphalt", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-asphalt-front-and-back-6a346abc4b8fe.jpg?v=1781820118" },
{ base:"tee", color:"team-purple", design:"norma-tee", ink:"black", handle:"norma-tee-1", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Team Purple", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-team-purple-front-and-back-6a34694b56dd1.jpg?v=1781819754" },
{ base:"tee", color:"team-purple", design:"norma-tee", ink:"white", handle:"norma-tee-black-version", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Team Purple", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-team-purple-front-and-back-6a346abc437e8.jpg?v=1781820118" },
{ base:"tee", color:"cardinal", design:"norma-tee", ink:"black", handle:"norma-tee-1", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Cardinal", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-cardinal-front-and-back-6a34694b58cec.jpg?v=1781819755" },
{ base:"tee", color:"cardinal", design:"norma-tee", ink:"white", handle:"norma-tee-black-version", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Cardinal", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-cardinal-front-and-back-6a346abc45bff.jpg?v=1781820117" },
{ base:"tee", color:"military-green", design:"norma-tee", ink:"black", handle:"norma-tee-1", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Military Green", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-military-green-front-and-back-6a34694b5b9fb.jpg?v=1781819755" },
{ base:"tee", color:"military-green", design:"norma-tee", ink:"white", handle:"norma-tee-black-version", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Military Green", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-military-green-front-and-back-6a346abc483f8.jpg?v=1781820118" },
{ base:"tee", color:"light-blue", design:"norma-tee", ink:"black", handle:"norma-tee-1", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Light Blue", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-light-blue-front-and-back-6a34694b6286a.jpg?v=1781819755" },
{ base:"tee", color:"light-blue", design:"norma-tee", ink:"white", handle:"norma-tee-black-version", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Light Blue", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-light-blue-front-and-back-6a346abc4fa2c.jpg?v=1781820118" },
{ base:"tee", color:"soft-pink", design:"norma-tee", ink:"black", handle:"norma-tee-1", sizes:["small","medium","large","xlarge"], variantColor:"Soft Pink", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-soft-pink-front-and-back-6a34694b77fdc.jpg?v=1781819755" },
{ base:"tee", color:"soft-pink", design:"norma-tee", ink:"white", handle:"norma-tee-black-version", sizes:["small","medium","large","xlarge"], variantColor:"Soft Pink", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-soft-pink-front-and-back-6a346abc60594.jpg?v=1781820117" },
{ base:"tee", color:"ocean-blue", design:"norma-tee", ink:"black", handle:"norma-tee-1", sizes:["small","medium","large","xlarge"], variantColor:"Ocean Blue", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-ocean-blue-front-and-back-6a34694b68a5f.jpg?v=1781819755" },
{ base:"tee", color:"ocean-blue", design:"norma-tee", ink:"white", handle:"norma-tee-black-version", sizes:["small","medium","large","xlarge"], variantColor:"Ocean Blue", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-ocean-blue-front-and-back-6a346abc54503.jpg?v=1781820118" },
{ base:"tee", color:"yellow", design:"norma-tee", ink:"black", handle:"norma-tee-1", sizes:["small","medium","large","xlarge"], variantColor:"Yellow", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-yellow-front-and-back-6a34694b70e2c.jpg?v=1781819755" },
{ base:"tee", color:"yellow", design:"norma-tee", ink:"white", handle:"norma-tee-black-version", sizes:["small","medium","large","xlarge"], variantColor:"Yellow", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-yellow-front-and-back-6a346abc59d93.jpg?v=1781820118" },
{ base:"tee", color:"black", design:"norma-signature", ink:"white", handle:"signature", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Black", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-black-front-and-back-6a14785b1ef97.jpg?v=1779726437" },
{ base:"tee", color:"white", design:"norma-signature", ink:"black", handle:"signature", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"White", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-white-front-and-back-6a14763657901_d675dc76-2894-4e11-846f-27be57e6c9b8.png?v=1779726315" },
{ base:"tee", color:"cream", design:"norma-signature", ink:"black", handle:"signature", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Cream/Black", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-vintage-white-front-and-back-6a1476365673f_3fa5fef9-801a-4ca7-b3fe-a2995b6ea138.png?v=1779726337" },
{ base:"tee", color:"cream", design:"norma-signature", ink:"white", handle:"signature", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Cream/White", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-vintage-white-front-and-back-6a1478761b654.jpg?v=1779726464" },
{ base:"tee", color:"asphalt", design:"norma-signature", ink:"black", handle:"signature", sizes:["small","medium","large","xlarge"], variantColor:"Asphalt", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-asphalt-front-and-back-6a147711f0aae.jpg?v=1779726109" },
{ base:"tee", color:"team-purple", design:"norma-signature", ink:"black", handle:"signature", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Team Purple", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-team-purple-front-and-back-6a247fd966546.jpg?v=1780776947" },
{ base:"tee", color:"cardinal", design:"norma-signature", ink:"black", handle:"signature", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Cardinal", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-cardinal-front-and-back-6a2480283084c.jpg?v=1780777017" },
{ base:"tee", color:"military-green", design:"norma-signature", ink:"black", handle:"signature", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Military Green", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-military-green-front-and-back-6a24802834c68.jpg?v=1780777017" },
{ base:"tee", color:"light-blue", design:"norma-signature", ink:"black", handle:"signature", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Light Blue", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-light-blue-front-and-back-6a2480ccbaea7.jpg?v=1780777181" },
{ base:"tee", color:"soft-pink", design:"norma-signature", ink:"black", handle:"signature", sizes:["small","medium","large","xlarge"], variantColor:"Soft Pink", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-soft-pink-front-and-back-6a2480ccbde21.jpg?v=1780777181" },
{ base:"tee", color:"ocean-blue", design:"norma-signature", ink:"black", handle:"signature", sizes:["small","medium","large","xlarge"], variantColor:"Ocean Blue", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-ocean-blue-front-and-back-6a24811cb76dd.jpg?v=1780777262" },
{ base:"tee", color:"yellow", design:"norma-signature", ink:"black", handle:"signature", sizes:["small","medium","large","xlarge"], variantColor:"Yellow", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-yellow-front-and-back-6a24811cba4fe.jpg?v=1780777262" },
{ base:"tee", color:"black", design:"crowned-norma", ink:"white", handle:"crownd-norma", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Black", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-black-front-and-back-6a147a613b6a9.jpg?v=1779726954" },
{ base:"tee", color:"white", design:"crowned-norma", ink:"black", handle:"crownd-norma", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"White", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-white-front-and-back-6a147ae5ee454.jpg?v=1779727087" },
{ base:"tee", color:"cream", design:"crowned-norma", ink:"black", handle:"crownd-norma", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Cream/Black", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-vintage-white-front-and-back-6a147aa06e664.jpg?v=1779727018" },
{ base:"tee", color:"cream", design:"crowned-norma", ink:"white", handle:"crownd-norma-whites", sizes:["small","medium","large","xlarge"], variantColor:"Vintage White", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-vintage-white-front-and-back-6a2c3d01b1f4d.jpg?v=1781284125" },
{ base:"tee", color:"asphalt", design:"crowned-norma", ink:"black", handle:"crownd-norma", sizes:["small","medium","large","xlarge"], variantColor:"Asphalt", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-asphalt-front-and-back-6a147a3aba994.jpg?v=1779726916" },
{ base:"tee", color:"asphalt", design:"crowned-norma", ink:"white", handle:"crownd-norma-whites", sizes:["small","medium","large","xlarge"], variantColor:"Asphalt", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-asphalt-front-and-back-6a2c283c2be4a.jpg?v=1781278808" },
{ base:"tee", color:"team-purple", design:"crowned-norma", ink:"black", handle:"crownd-norma", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Team Purple", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-team-purple-front-and-back-6a25e5b470877.jpg?v=1780868557" },
{ base:"tee", color:"team-purple", design:"crowned-norma", ink:"white", handle:"crownd-norma-whites", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Team Purple", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-team-purple-front-and-back-6a25e87cf3cf1.jpg?v=1780869271" },
{ base:"tee", color:"cardinal", design:"crowned-norma", ink:"black", handle:"crownd-norma", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Cardinal", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-cardinal-front-and-back-6a25e5b4740a4.jpg?v=1780868557" },
{ base:"tee", color:"cardinal", design:"crowned-norma", ink:"white", handle:"crownd-norma-whites", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Cardinal", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-cardinal-front-and-back-6a25e87d02e1f.jpg?v=1780869271" },
{ base:"tee", color:"military-green", design:"crowned-norma", ink:"black", handle:"crownd-norma", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Military Green", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-military-green-front-and-back-6a25e5b4782d2.jpg?v=1780868558" },
{ base:"tee", color:"military-green", design:"crowned-norma", ink:"white", handle:"crownd-norma-whites", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Military Green", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-military-green-front-and-back-6a25e87d069a2.jpg?v=1780869271" },
{ base:"tee", color:"light-blue", design:"crowned-norma", ink:"black", handle:"crownd-norma", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Baby Blue", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-baby-blue-front-and-back-6a25e605a69bf.jpg?v=1780868633" },
{ base:"tee", color:"light-blue", design:"crowned-norma", ink:"white", handle:"crownd-norma-whites", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Baby Blue", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-baby-blue-front-and-back-6a25ec9e61ba5.jpg?v=1780870321" },
{ base:"tee", color:"soft-pink", design:"crowned-norma", ink:"black", handle:"crownd-norma", sizes:["small","medium","large","xlarge"], variantColor:"Soft Pink", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-soft-pink-front-and-back-6a25e605aa740.jpg?v=1780868633" },
{ base:"tee", color:"soft-pink", design:"crowned-norma", ink:"white", handle:"crownd-norma-whites", sizes:["small","medium","large","xlarge"], variantColor:"Soft Pink", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-soft-pink-front-and-back-6a25ec9e65c8b.jpg?v=1780870322" },
{ base:"tee", color:"ocean-blue", design:"crowned-norma", ink:"black", handle:"crownd-norma", sizes:["small","medium","large","xlarge"], variantColor:"Ocean Blue", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-ocean-blue-front-and-back-6a25e6526a74f.jpg?v=1780868706" },
{ base:"tee", color:"ocean-blue", design:"crowned-norma", ink:"white", handle:"crownd-norma-whites", sizes:["small","medium","large","xlarge"], variantColor:"Ocean Blue", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-ocean-blue-front-and-back-6a25eceeb310a.jpg?v=1780870401" },
{ base:"tee", color:"yellow", design:"crowned-norma", ink:"black", handle:"crownd-norma", sizes:["small","medium","large","xlarge"], variantColor:"Yellow", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-yellow-front-and-back-6a25e6c011e49.jpg?v=1780868816" },
{ base:"tee", color:"yellow", design:"crowned-norma", ink:"white", handle:"crownd-norma-whites", sizes:["small","medium","large","xlarge"], variantColor:"Yellow", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-yellow-front-and-back-6a25ed440fa92.jpg?v=1780870483" },
{ base:"tee", color:"black", design:"oboi", ink:"white", handle:"unisex-t-shirt-2", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Black", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-black-front-and-back-6a823dd8bc9ba.jpg?v=1786920432" },
{ base:"tee", color:"team-purple", design:"oboi", ink:"white", handle:"unisex-t-shirt-2", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Team Purple", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-team-purple-front-and-back-6a823dd8be957.jpg?v=1786920432" },
{ base:"tee", color:"cardinal", design:"oboi", ink:"white", handle:"unisex-t-shirt-2", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Cardinal", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-cardinal-front-and-back-6a823dd8c0615.jpg?v=1786920432" },
{ base:"tee", color:"military-green", design:"oboi", ink:"white", handle:"unisex-t-shirt-2", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Military Green", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-military-green-front-and-back-6a823dd8c2923.jpg?v=1786920433" },
{ base:"tee", color:"asphalt", design:"oboi", ink:"white", handle:"unisex-t-shirt-2", sizes:["small","medium","large","xlarge"], variantColor:"Asphalt", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-asphalt-front-and-back-6a823dd8c5584.jpg?v=1786920432" },
{ base:"tee", color:"light-blue", design:"oboi", ink:"white", handle:"unisex-t-shirt-2", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Light Blue", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-light-blue-front-and-back-6a823dd8c8637.jpg?v=1786920432" },
{ base:"tee", color:"ocean-blue", design:"oboi", ink:"white", handle:"unisex-t-shirt-2", sizes:["small","medium","large","xlarge"], variantColor:"Ocean Blue", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-ocean-blue-front-and-back-6a823dd8cbb67.jpg?v=1786920432" },
{ base:"tee", color:"cream", design:"oboi", ink:"white", handle:"unisex-t-shirt-2", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Soft Cream", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-soft-cream-front-and-back-6a823dd8cf88c.jpg?v=1786920433" },
{ base:"tee", color:"yellow", design:"oboi", ink:"white", handle:"unisex-t-shirt-2", sizes:["small","medium","large","xlarge"], variantColor:"Yellow", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-yellow-front-and-back-6a823dd8d3f02.jpg?v=1786920432" },
{ base:"tee", color:"soft-pink", design:"oboi", ink:"white", handle:"unisex-t-shirt-2", sizes:["small","medium","large","xlarge"], variantColor:"Soft Pink", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-soft-pink-front-and-back-6a823dd8d8f8f.jpg?v=1786920433" },
{ base:"tee", color:"team-purple", design:"oboi", ink:"black", handle:"oboi", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Team Purple", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-team-purple-front-and-back-6a8236690ed81.jpg?v=1786918534" },
{ base:"tee", color:"cardinal", design:"oboi", ink:"black", handle:"oboi", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Cardinal", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-cardinal-front-and-back-6a8236690fd9b.jpg?v=1786918534" },
{ base:"tee", color:"military-green", design:"oboi", ink:"black", handle:"oboi", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Military Green", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-military-green-front-and-back-6a82366911574.jpg?v=1786918535" },
{ base:"tee", color:"asphalt", design:"oboi", ink:"black", handle:"oboi", sizes:["small","medium","large","xlarge"], variantColor:"Asphalt", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-asphalt-front-and-back-6a823669135af.jpg?v=1786918535" },
{ base:"tee", color:"light-blue", design:"oboi", ink:"black", handle:"oboi", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Light Blue", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-light-blue-front-and-back-6a82366915cb0.jpg?v=1786918535" },
{ base:"tee", color:"ocean-blue", design:"oboi", ink:"black", handle:"oboi", sizes:["small","medium","large","xlarge"], variantColor:"Ocean Blue", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-ocean-blue-front-and-back-6a82366918baa.jpg?v=1786918535" },
{ base:"tee", color:"cream", design:"oboi", ink:"black", handle:"oboi", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Soft Cream", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-soft-cream-front-and-back-6a8236691c138.jpg?v=1786918534" },
{ base:"tee", color:"yellow", design:"oboi", ink:"black", handle:"oboi", sizes:["small","medium","large","xlarge"], variantColor:"Yellow", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-yellow-front-and-back-6a8236691ff36.jpg?v=1786918534" },
{ base:"tee", color:"soft-pink", design:"oboi", ink:"black", handle:"oboi", sizes:["small","medium","large","xlarge"], variantColor:"Soft Pink", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-soft-pink-front-and-back-6a82366924329.jpg?v=1786918535" },
{ base:"tee", color:"white", design:"oboi", ink:"black", handle:"oboi", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"White", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-white-front-and-back-6a82366908119.jpg?v=1786918534" },
{ base:"tee", color:"black", design:"oboi", ink:"black", handle:"oboi", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Black", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/unisex-staple-t-shirt-black-front-and-back-6a8242f38a36a.jpg?v=1786921727" },
{ base:"tanktop", color:"black", design:"norma-1st-edition", ink:"white", handle:"norma-1st-edition", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Black", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/womens-micro-rib-tank-top-solid-black-blend-front-69b38303c051a.jpg?v=1773372176" },
{ base:"tanktop", color:"white", design:"norma-1st-edition", ink:"black", handle:"norma-1st-edition", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"White", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/womens-micro-rib-tank-top-solid-white-blend-front-69b381deaec4d.jpg?v=1773371882" },
{ base:"tanktop", color:"pink", design:"norma-1st-edition", ink:"white", handle:"norma-1st-edition", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Pink", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/womens-micro-rib-tank-top-solid-pink-blend-front-69b3847767074.jpg?v=1773372547" },
{ base:"tanktop", color:"light-blue", design:"norma-1st-edition", ink:"white", handle:"norma-1st-edition", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Blue", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/womens-micro-rib-tank-top-solid-baby-blue-blend-front-69b386a39842a.jpg?v=1773373105" },
{ base:"tanktop", color:"black", design:"norma-signature", ink:"white", handle:"norma-signature", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Black", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/womens-micro-rib-tank-top-solid-black-blend-front-69b392edcfd87.jpg?v=1773376253" },
{ base:"tanktop", color:"white", design:"norma-signature", ink:"black", handle:"norma-signature", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"White", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/womens-micro-rib-tank-top-solid-white-blend-front-69b38bbbd59d7.jpg?v=1773374414" },
{ base:"tanktop", color:"pink", design:"norma-signature", ink:"white", handle:"norma-signature", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Pink", preview:"https://cdn.shopify.com/s/files/1/0766/6103/1153/files/womens-micro-rib-tank-top-solid-pink-blend-front-69b39463964ec.jpg?v=1773376622" },
{ base:"tanktop", color:"light-blue", design:"norma-signature", ink:"white", handle:"norma-signature", sizes:["xsmall","small","medium","large","xlarge"], variantColor:"Blue", preview:"https://shopnorma.com/cdn/shop/files/womens-micro-rib-tank-top-solid-baby-blue-blend-front-69b3939f2f741.jpg?v=1773376428&width=3840" }
]
};
function startNormafyBuilder() {
var builder = document.querySelector(".normafy-builder");
if (!builder || builder.getAttribute("data-loaded") === "true") return;
builder.setAttribute("data-loaded", "true");
var NORMA_PRODUCT_DATA = readNormafyProductData(builder);
var selections = { base:null, baseColor:null, design:null, designColor:null, size:null };
var currentCombination = null;
function unique(values) {
return values.filter(function (value, index, array) {
return array.indexOf(value) === index;
});
}
function getMatchingCombinations(partial) {
return CATALOG.combinations.filter(function (combo) {
return Object.keys(partial).every(function (key) {
return !partial[key] || combo[key] === partial[key];
});
});
}
function getAvailableBases() {
return unique(CATALOG.combinations.map(function (c) { return c.base; }));
}
function getAvailableColors() {
return unique(getMatchingCombinations({ base: selections.base }).map(function (c) { return c.color; }));
}
function getAvailableDesigns() {
return unique(getMatchingCombinations({ base: selections.base, color: selections.baseColor }).map(function (c) { return c.design; }));
}
function getAvailableInks() {
return unique(getMatchingCombinations({
base: selections.base,
color: selections.baseColor,
design: selections.design
}).map(function (c) { return c.ink; }));
}
function getAvailableSizes() {
var combos = getMatchingCombinations({
base: selections.base,
color: selections.baseColor,
design: selections.design,
ink: selections.designColor
});
var sizes = [];
combos.forEach(function (combo) { sizes = sizes.concat(combo.sizes || []); });
return unique(sizes);
}
function exactCombination() {
return getMatchingCombinations({
base: selections.base,
color: selections.baseColor,
design: selections.design,
ink: selections.designColor
})[0] || null;
}
function makeChoiceButton(choice, value, className, innerHTML) {
var button = document.createElement("button");
button.type = "button";
button.className = className;
button.setAttribute("data-choice", choice);
button.setAttribute("data-value", value);
button.innerHTML = innerHTML;
return button;
}
function renderBases() {
var container = builder.querySelector("#normafyBaseOptions");
container.innerHTML = "";
getAvailableBases().forEach(function (key) {
var item = CATALOG.bases[key];
if (!item) return;
container.appendChild(makeChoiceButton(
"base", key, "base-card",
(item.image ? '<img src="' + item.image + '" alt="' + item.label + '">' : '') + '<span>' + item.label + '</span>'
));
});
}
function renderColors() {
var container = builder.querySelector("#normafyBaseColorOptions");
container.innerHTML = "";
getAvailableColors().forEach(function (key) {
var item = CATALOG.colors[key];
if (!item) return;
var borderClass = item.border ? " white-swatch" : "";
container.appendChild(makeChoiceButton(
"baseColor", key, "color-swatch",
'<span class="swatch-circle' + borderClass + '" style="background:' + item.swatch + ';"></span>' +
'<span class="swatch-name">' + item.label + '</span>'
));
});
}
function renderDesigns() {
var container = builder.querySelector("#normafyDesignOptions");
container.innerHTML = "";
getAvailableDesigns().forEach(function (key) {
var item = CATALOG.designs[key];
if (!item) return;
container.appendChild(makeChoiceButton(
"design", key, "design-card",
(item.image ? '<img src="' + item.image + '" alt="' + item.label + '">' : '') + '<span></span>'
));
});
}
function renderInks() {
var container = builder.querySelector("#normafyInkOptions");
container.innerHTML = "";
getAvailableInks().forEach(function (key) {
var item = CATALOG.inks[key];
if (!item) return;
var borderClass = item.border ? " white-swatch" : "";
container.appendChild(makeChoiceButton(
"designColor", key, "color-swatch",
'<span class="swatch-circle' + borderClass + '" style="background:' + item.swatch + ';"></span>' +
'<span class="swatch-name">' + item.label + '</span>'
));
});
}
function renderSizes() {
var container = builder.querySelector("#normafySizeOptions");
container.innerHTML = "";
getAvailableSizes().forEach(function (key) {
var item = CATALOG.sizes[key];
if (!item) return;
container.appendChild(makeChoiceButton("size", key, "normafy-option", item.label));
});
}
function label(group, key) {
return CATALOG[group] && CATALOG[group][key] ? CATALOG[group][key].label : "";
}
function updateSummary() {
var summary = builder.querySelector("#normafy-summary");
summary.innerHTML =
"<strong>Base:</strong> " + label("bases", selections.base) + "<br>" +
"<strong>Base Color:</strong> " + label("colors", selections.baseColor) + "<br>" +
"<strong>Design:</strong> " + label("designs", selections.design) + "<br>" +
"<strong>Design Color:</strong> " + label("inks", selections.designColor) + "<br>" +
"<strong>Size:</strong> " + label("sizes", selections.size);
}
function updateProgressBar(stepNumber) {
var percentages = {1:"16.6%",2:"33.2%",3:"49.8%",4:"66.4%",5:"83%",6:"100%"};
builder.querySelector("#normafyProgressFill").style.width = percentages[stepNumber] || "16.6%";
}
function showStep(stepNumber) {
builder.querySelectorAll(".normafy-step").forEach(function (step) {
step.classList.remove("active");
});
var target = builder.querySelector('[data-step="' + stepNumber + '"]');
if (target) target.classList.add("active");
updateProgressBar(stepNumber);
updateSizeChart();
}
function updateSizeChart() {
builder.querySelectorAll(".size-chart-content").forEach(function (chart) {
chart.classList.remove("active", "has-image");
});
var base = CATALOG.bases[selections.base];
if (!base) return;
var chart = builder.querySelector("#" + base.sizeChartId);
if (!chart) return;
chart.classList.add("active");
var image = chart.querySelector("img");
if (image && image.getAttribute("src")) chart.classList.add("has-image");
}
function normalizeOption(value) {
return String(value || "").toLowerCase().replace(/\s*\/\s*/g, "/").replace(/\s+/g, " ").trim();
}
function shopifyBaseColor(combo) {
if (combo.color === "light-blue" && combo.base === "tanktop") return "Blue";
if (combo.color === "light-blue" && combo.design === "crowned-norma") return "Baby Blue";
if (combo.color === "cream" && combo.design === "crowned-norma") return "Vintage White";
return label("colors", combo.color);
}
function shopifyVariantColor(combo) {
if (combo.variantColor) return combo.variantColor;
return shopifyBaseColor(combo) + "/" + label("inks", combo.ink);
}
function addUniqueOption(list, value) {
value = normalizeOption(value);
if (value && list.indexOf(value) === -1) list.push(value);
}
function variantColorCandidates(combo) {
var candidates = [];
addUniqueOption(candidates, shopifyVariantColor(combo));
addUniqueOption(candidates, combo.variantColor);

if (combo.base === "tee" && combo.design === "norma-signature") {
if (combo.color === "cream") {
addUniqueOption(candidates, combo.ink === "white" ? "Cream/White" : "Cream/Black");
} else {
addUniqueOption(candidates, label("colors", combo.color));
}
}

if (combo.color === "cream") {
addUniqueOption(candidates, "Cream/" + label("inks", combo.ink));
addUniqueOption(candidates, combo.ink === "white" ? "Cream/White" : "Cream/Black");
addUniqueOption(candidates, "Vintage White");
addUniqueOption(candidates, "Vintage White/" + label("inks", combo.ink));
addUniqueOption(candidates, "Cream");
}
if (combo.color === "light-blue") {
addUniqueOption(candidates, "Light Blue");
addUniqueOption(candidates, "Baby Blue");
addUniqueOption(candidates, "Blue");
}
addUniqueOption(candidates, shopifyBaseColor(combo));
addUniqueOption(candidates, label("colors", combo.color));
return candidates;
}
function findMatchingVariant(product, combo) {
if (!product || !Array.isArray(product.variants)) return null;
if (!selections.size || !CATALOG.sizes[selections.size]) return null;

var wantedSize = normalizeOption(CATALOG.sizes[selections.size].shopify);
var colorCandidates = variantColorCandidates(combo);

for (var i = 0; i < product.variants.length; i++) {
  var variant = product.variants[i];
  var options = (variant.options || []).map(normalizeOption);

  if (options.indexOf(wantedSize) === -1) continue;

  for (var c = 0; c < colorCandidates.length; c++) {
    if (options.indexOf(colorCandidates[c]) !== -1) {
      return variant;
    }
  }
}

return null;
}
function loadProduct(handle) {
var embeddedProduct = NORMA_PRODUCT_DATA[handle];

if (embeddedProduct && embeddedProduct.variants && embeddedProduct.variants.length) {
  return Promise.resolve(embeddedProduct);
}

return fetch("/products/" + encodeURIComponent(handle) + ".js", {
  credentials: "same-origin",
  headers: { "Accept": "application/json" }
}).then(function (response) {
  if (!response.ok) {
    throw new Error(
      "NÖRMAFY product is unavailable to the Online Store: " +
      handle +
      " (HTTP " +
      response.status +
      ")"
    );
  }
  return response.json();
});
}
function auditCatalog() {
var issues = [];

Object.keys(NORMA_PRODUCT_DATA).forEach(function (handle) {
  var product = NORMA_PRODUCT_DATA[handle];
  if (!product || !product.variants || !product.variants.length) {
    issues.push("Product data unavailable: " + handle);
  }
});

CATALOG.combinations.forEach(function (combo) {
  var product = NORMA_PRODUCT_DATA[combo.handle];
  if (!product || !product.variants || !product.variants.length) return;

  var candidates = variantColorCandidates(combo);
  var hasAnyMatchingColor = product.variants.some(function (variant) {
    var options = (variant.options || []).map(normalizeOption);
    return candidates.some(function (candidate) {
      return options.indexOf(candidate) !== -1;
    });
  });

  if (!hasAnyMatchingColor) {
    issues.push(
      "No matching Shopify color for " +
      combo.base + " / " +
      combo.color + " / " +
      combo.design + " / " +
      combo.ink + " on " +
      combo.handle
    );
  }
});

if (issues.length) {
  console.warn("NÖRMAFY catalog audit:", issues);
} else {
  console.info("NÖRMAFY catalog audit: no mapping issues detected.");
}
}

function setPreview(url, fallbackText) {
var image = builder.querySelector("#previewProductImage");
var text = builder.querySelector("#previewImageText");
image.onload = function () {
image.style.display = "block";
text.style.display = "none";
};
image.onerror = function () {
image.style.display = "none";
text.style.display = "block";
text.innerText = fallbackText || "This image could not load.";
};
image.style.display = "none";
text.style.display = "block";
text.innerText = "Loading product preview...";
image.src = url || "";
if (!url) text.innerText = fallbackText || "No preview image has been added for this selection.";
}
function updatePreview() {
currentCombination = exactCombination();
if (!currentCombination) {
setPreview("", "This combination is not connected.");
return;
}
if (!currentCombination.preview || String(currentCombination.preview).indexOf("PASTE ") === 0) {
setPreview("", "No exact preview image is assigned to this selection yet. Paste the image link in the NÖRMA TEE PREVIEW IMAGE LINKS section.");
return;
}
setPreview(currentCombination.preview, "This exact preview image could not load.");
}
function clearLaterSelections(choice) {
var order = ["base","baseColor","design","designColor","size"];
var index = order.indexOf(choice);
for (var i = index + 1; i < order.length; i++) selections[order[i]] = null;
}
builder.addEventListener("click", function (event) {
var choiceButton = event.target.closest("[data-choice]");
var backButton = event.target.closest("[data-back]");
var cartButton = event.target.closest("#normafy-add-to-cart");
if (choiceButton && builder.contains(choiceButton)) {
var choice = choiceButton.getAttribute("data-choice");
var value = choiceButton.getAttribute("data-value");
selections[choice] = value;
clearLaterSelections(choice);
builder.querySelectorAll('[data-choice="' + choice + '"]').forEach(function (button) {
button.classList.remove("selected-choice", "choice-pop");
});
choiceButton.classList.add("selected-choice", "choice-pop");
setTimeout(function () { choiceButton.classList.remove("choice-pop"); }, 300);
if (choice === "base") {
builder.querySelector("#baseColorTitle").innerText = "Choose your " + label("bases", value) + " color";
renderColors();
showStep(2);
} else if (choice === "baseColor") {
renderDesigns();
showStep(3);
} else if (choice === "design") {
renderInks();
showStep(4);
} else if (choice === "designColor") {
renderSizes();
showStep(5);
} else if (choice === "size") {
updateSummary();
updatePreview();
showStep(6);
}
}
if (backButton && builder.contains(backButton)) {
showStep(Number(backButton.getAttribute("data-back")));
}
if (cartButton && builder.contains(cartButton)) {
var error = builder.querySelector("#normafy-error");
error.innerText = "";
var policyCheck = builder.querySelector("#normafy-policy-check");
if (policyCheck && !policyCheck.checked) {
error.innerText = "Please agree to the return policy before adding to cart.";
return;
}
currentCombination = exactCombination();
if (!currentCombination || !selections.size) {
error.innerText = "This selection is not completely connected.";
return;
}
cartButton.innerText = "Adding...";
cartButton.disabled = true;
loadProduct(currentCombination.handle)
.then(function (product) {
var variant = findMatchingVariant(product, currentCombination);
if (!variant) throw new Error("Matching variant not found");
if (variant.available === false) throw new Error("Variant sold out");
return fetch("/cart/add.js", {
method: "POST",
headers: {"Content-Type":"application/json","Accept":"application/json"},
body: JSON.stringify({
items: [{
id: variant.id,
quantity: 1,
properties: {
"Base": label("bases", selections.base),
"Base Color": label("colors", selections.baseColor),
"Design": label("designs", selections.design),
"Design Color": label("inks", selections.designColor),
"Size": label("sizes", selections.size)
}
}]
})
});
})
.then(function (response) {
if (!response.ok) throw new Error("Cart error");
window.location.href = "/cart";
})
.catch(function (err) {
console.error("NÖRMAFY add-to-cart error:", err);
error.innerText = "This exact piece is not connected correctly right now. Please try another option.";
cartButton.innerText = "Add to Cart";
cartButton.disabled = false;
});
}
});
renderBases();
updateSizeChart();
auditCatalog();

var params = new URLSearchParams(window.location.search);
var presetBase = params.get("base");

if (presetBase === "tee" || presetBase === "tanktop") {
  selections.base = presetBase;

  builder.querySelector("#baseColorTitle").innerText =
    "Choose your " + label("bases", presetBase) + " color";

  renderColors();
  showStep(2);
}
}

function initNormafyBuilder() {
  try {
    startNormafyBuilder();
  } catch (error) {
    console.error("NÖRMAFY init error:", error);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initNormafyBuilder, { once: true });
} else {
  initNormafyBuilder();
}

document.addEventListener("shopify:section:load", initNormafyBuilder);
})();
